export const readFile = (..._args: unknown[]) => {
  throw new Error('fs.readFile is not available in the browser')
}

export default { readFile }